import type { GenerationMode } from "~/shared/data/chat-models";

// Имена режимов у фронта и бэкенда совпадают один-в-один, поэтому переводить
// нечего — эта функция только приводит строку каталога к типу режима.
//
// 🛑 Раньше здесь жил UI-алиас `upscale`, схлопывавший `upscale_image` и
// `upscale_video` в одно значение, а обратно разворачивавшийся по типу
// артефакта. Карточка Topaz объявляет ОБА режима, и алиас превращал их в две
// одинаковые строки «Image Upscale», из-за чего апскейл видео не доходил до
// пользователя вовсе. Схлопывать режимы каталога нельзя: их различает бэкенд.

export function toGenerationMode(backendMode: string): GenerationMode {
    return backendMode as GenerationMode;
}
